import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LightbulbIcon from "@mui/icons-material/Lightbulb";

const styles = (theme) => ({
  tipBox: {
    backgroundColor: "rgba(232, 163, 61, 0.1)",
    border: "1px solid rgba(232, 163, 61, 0.3)",
    borderRadius: "8px",
    padding: "0.75rem",
    display: "flex",
    alignItems: "flex-start",
    gap: "0.75rem",
  },
  tipIcon: {
    color: "#E8A33D",
    fontSize: "1.2rem",
    flexShrink: 0,
    marginTop: "0.1rem",
  },
  tipText: {
    fontSize: "0.85rem",
    color: "rgba(255,255,255,0.9)",
    lineHeight: 1.5,
  },
  tipTitle: {
    fontSize: "0.9rem",
    fontWeight: 700,
    color: "#E8A33D",
    marginBottom: "0.25rem",
  },
});

function TipCard({ classes, title, text }) {
  return (
    <Box className={classes.tipBox}>
      <LightbulbIcon className={classes.tipIcon} />
      <div>
        {title && <Typography className={classes.tipTitle}>{title}</Typography>}
        <Typography className={classes.tipText}>{text}</Typography>
      </div>
    </Box>
  );
}

TipCard.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
};

export default withStyles(styles)(TipCard);
